import { render, staticRenderFns } from "./viewCountryDialog.vue?vue&type=template&id=0132188b&scoped=true"
import script from "./viewCountryDialog.vue?vue&type=script&lang=js"
export * from "./viewCountryDialog.vue?vue&type=script&lang=js"
import style0 from "./viewCountryDialog.vue?vue&type=style&index=0&id=0132188b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0132188b",
  null
  
)

export default component.exports